<template>
  <AuthLayout :title="$route.params.token ? 'Nouveau mot de passe' : 'Mot de passe oublié'">
    <NewPasswordForm v-if="this.$route.params.token"/>
    <ResetPasswordForm v-else/>
  </AuthLayout>
</template>

<script>
    import ResetPasswordForm from "../components/forms/ResetPasswordForm.vue";
    import NewPasswordForm from "@/components/forms/NewPasswordForm.vue";
    import AuthLayout from "@/components/public/AuthLayout.vue";
    import {useHead} from "@vueuse/head";

    export default {
        name: 'ResetPasswordView',
        components: {
            ResetPasswordForm,
            NewPasswordForm,
            AuthLayout,
        },
      mounted() {
        useHead({
          title: 'Réinitialisation du mot de passe - Logiciel de facturation électronique',
          meta: [
            {
              name: 'robots',
              content: 'noindex, nofollow'
            }
          ]
        })
      }
    }
</script>
